import DOMPurify from 'isomorphic-dompurify';

export const useSanitize = () => {
    const sanitize = (defaultContent, options = {}) => {
        if (!defaultContent) {
            return '';
        }

        const defaultOptions = {
            ALLOWED_TAGS: ['b', 'i', 'em', 'strong', 'a', 'span', 'br', 'u'],
            ALLOWED_ATTR: ['href', 'class', 'target', 'rel'],
            ALLOW_DATA_ATTR: false
        };

        return DOMPurify.sanitize(defaultContent, { ...defaultOptions, ...options });
    };

    const sanitizeTitle = (title) => {
        return sanitize(title, {
            ALLOWED_TAGS: ['b', 'i', 'em', 'strong', 'span', 'br'],
            ALLOWED_ATTR: ['class']
        });
    };

    const sanitizeContent = (content) => {
        return sanitize(content, {
            ALLOWED_TAGS: ['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'p', 'b', 'i', 'em', 'u', 'strong', 'a', 'ul', 'ol', 'li', 'br'],
            ALLOWED_ATTR: ['href', 'class', 'target', 'rel']
        });
    };

    const sanitizeButton = (content) => {
        return sanitize(content, {
            ALLOWED_TAGS: ['b', 'i', 'em', 'strong', 'br'],
            ALLOWED_ATTR: ['href', 'class', 'target', 'rel']
        });
    };

    return {
        sanitize,
        sanitizeTitle,
        sanitizeContent,
        sanitizeButton
    };
};